// Instituciones: resolución del tenant (pública), marca de la institución activa (admin) y
// alta/edición de instituciones (SuperAdmin).
import { apiFetch, json } from './apiFetch';
import { getToken } from './sesion';

// ¿Qué institución corresponde a este host? En modo plataforma se envía el slug tomado del
// primer segmento de la ruta; en modo dominio la API lo ignora, salvo para un SuperAdmin
// autenticado (por eso se adjunta el token cuando hay sesión).
export const getInstitucionActual = (slug) => {
  const query = slug ? `?slug=${encodeURIComponent(slug)}` : '';
  return apiFetch(`/api/instituciones/actual${query}`, { auth: Boolean(getToken()) });
};

export const getInstituciones = () => apiFetch('/api/instituciones');

// --- Admin: marca de la institución del tenant ---
export const getInstitucionActiva = () =>
  apiFetch('/api/admin/instituciones/actual', { auth: true });

// datos: { nombre, nombreCorto, descripcion, tituloPagina, colorPrimario, colorSecundario, colorAcento, tema }
export const actualizarBranding = (datos) =>
  apiFetch('/api/admin/instituciones/actual', { method: 'PUT', auth: true, ...json(datos) });

export const subirLogo = (archivo) => {
  const fd = new FormData();
  fd.append('Archivo', archivo);
  return apiFetch('/api/admin/instituciones/actual/logo', { method: 'POST', auth: true, body: fd });
};

// --- SuperAdmin: todas las instituciones ---
export const getInstitucionesAdmin = () =>
  apiFetch('/api/admin/instituciones', { auth: true });

export const getInstitucionAdmin = (id) =>
  apiFetch(`/api/admin/instituciones/${id}`, { auth: true });

// datos: branding + { slug?, orden, dominios: [] }
export const crearInstitucion = (datos) =>
  apiFetch('/api/admin/instituciones', { method: 'POST', auth: true, ...json(datos) });

export const actualizarInstitucion = (id, datos) =>
  apiFetch(`/api/admin/instituciones/${id}`, { method: 'PUT', auth: true, ...json(datos) });

export const cambiarEstadoInstitucion = (id, activo) =>
  apiFetch(`/api/admin/instituciones/${id}/estado`, { method: 'PATCH', auth: true, ...json({ activo }) });

export const subirLogoInstitucion = (id, archivo) => {
  const fd = new FormData();
  fd.append('Archivo', archivo);
  return apiFetch(`/api/admin/instituciones/${id}/logo`, { method: 'POST', auth: true, body: fd });
};
